import { useState, useEffect } from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailEditor from "react-email-editor";
import AckLog from "./AckLog";


const Editor = ({ open, close, selectedMessage, editorRef, save }) => {
  const [title, setTitle] = useState("");
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (selectedMessage) {
        setTitle(selectedMessage.title)
    }
  },[selectedMessage])
  
  const onReady = (unlayer) => {
    if (selectedMessage?.jsonBody) {
        unlayer.loadDesign(selectedMessage.jsonBody)
    }
  }
  
  const handleSave = async () => {
    if (!title) {
      alert("Please enter a title");
      return;
    }

    const unlayer = editorRef.current?.editor;

    if (unlayer) {
      unlayer.exportHtml(function (d) {
        const data = {
          title,
          active,
          type: 'general',
          htmlBody: d.html,
          jsonBody: d.design,
        };
        if (!selectedMessage) data.create = true;
        save(data)
      });
    } else {
      console.warn("Unlayer editor not ready");
    }
  };

  return (
    <Dialog fullScreen open={open} onClose={close}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {selectedMessage ? selectedMessage?.title : "Create New"}
          </Typography>
          <Button autoFocus color="inherit" onClick={handleSave}>
            save
          </Button>
        </Toolbar>
      </AppBar>

      <DialogContent style={{ paddingTop: 20 }}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={6} style={{display: 'flex', justifyContent:'center'}}>
            <TextField
              size="small"
              style={{width: 400}}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
            />
          </Grid>
          <Grid item xs={6} style={{display: 'flex', justifyContent:'center'}}>
            <FormControlLabel
              control={
                <Switch checked={active} onChange={() => setActive(!active)} />
              }
              label="Active"
            />
          </Grid>
          <Grid item xs={12}>
            <EmailEditor ref={editorRef} options={{ displayMode: "email" }} onReady={onReady}/>
          </Grid>
        <Grid item>
          <AckLog messageId={selectedMessage?._id} />
        </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Editor;
